// 🚨 AUTO-GENERADO desde BuyInvoiceDataType.ts - No editar manualmente

export const BuyInvoiceFormDataKeys = [
  "id",
  "numero",
  "sequence",
  "invoice_key",
  "tipo",
  "nombre_factura",
  "tel1",
  "tel1_cd",
  "tel2",
  "tel2_cd",
  "email",
  "direccion",
  "clientActivitycode",
  "fecha",
  "porcenta_descuento",
  "subtotal",
  "descuento",
  "discountCode",
  "impuestos",
  "impuestos_servicio",
  "total",
  "anulada",
  "tipo_identificacion",
  "identificacion",
  "pagada",
  "status",
  "saleCondition",
  "exenta",
  "exchange_rate",
  "einvoice_status",
  "edocument_status_payload",
  "document_comments",
  "customfields",
  "info_references",
  "otros_cargos",
  "plazo",
  "activitycode",
  "province_id",
  "canton_id",
  "district_id",
  "ref_doctype",
  "ref_numero",
  "ref_date",
  "ref_razon",
  "ref_codigo",
  "buyInvoiceType",
  "providerId",
  "provider",
  "currencyId",
  "currency",
  "providerRecibeId",
  "buyInvoiceProducts",
  "buyInvoicePayments",
  "user",
  "razon_social",
  "client",
  "reference_number"
] as const;
